import { useContext } from 'react';

import { TemplateParamsContext } from '@/context';

export function useTemplateParams() {
  return useContext(TemplateParamsContext);
}

export default useTemplateParams;
